import React from 'react';
import { MainCategoryProps } from '../MainCategory';
import { getBeneficiaryIcon } from '../BeneficiaryMainCard';
import BeneficiarySection from '../BeneficiarySection';
import BeneficiarySingleValue from '../BeneficiaryValues/BeneficiarySingleValue';
import {
  Beneficiaries,
  BeneficiaryTitleInfoProps,
} from '../utils/beneficiaryInterfaces';
import { beneficiaryTitle } from '../utils/helperComponents';

const minWidth = 256;

interface BeneficiaryWorkProps extends BeneficiaryTitleInfoProps {
  beneficiary: Beneficiaries['work'];
  setBeneficiaries: MainCategoryProps['setBeneficiaries'];
}

const BeneficiaryWork: React.FC<BeneficiaryWorkProps> = ({
  beneficiary,
  beneficiaryLabel,
  programName,
  setBeneficiaries,
}) => {
  if (beneficiary === undefined) return null;
  return (
    <BeneficiarySection
      icon={getBeneficiaryIcon('work')}
      setBeneficiaries={setBeneficiaries}
      category="work"
      heading="Work status and occupations"
      title={beneficiaryTitle(
        'the Work status and occupations',
        programName,
        beneficiaryLabel,
      )}
      note={undefined}
    >
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Students"
        buttonLabel="Students"
        inputLabel="Students"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Students"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Unemployed people"
        buttonLabel="Unemployed people"
        inputLabel="Unemployed people"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Unemployed people"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Veterans"
        buttonLabel="Veterans"
        inputLabel="Veterans"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Veterans"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Self-employed people"
        buttonLabel="Self-employed people"
        inputLabel="Self-employed people"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Self-employed people"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Retired people"
        buttonLabel="Retired people"
        inputLabel="Retired people"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Retired people"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Domestic workers"
        buttonLabel="Domestic workers"
        inputLabel="Domestic workers"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Domestic workers"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Military personnel"
        buttonLabel="Military personnel"
        inputLabel="Military personnel"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Military personnel"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Farmers"
        buttonLabel="Farmers"
        inputLabel="Farmers"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Farmers"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Artists and performers"
        buttonLabel="Artists and performers"
        inputLabel="Artists and performers"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Artists and performers"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Emergency responders"
        buttonLabel="Emergency responders"
        inputLabel="Emergency responders"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Emergency responders"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Teachers"
        buttonLabel="Teachers"
        inputLabel="Teachers"
        categoryName="work"
        category={beneficiary.categories}
        fieldName="Teachers"
        setBeneficiaries={setBeneficiaries}
      />
    </BeneficiarySection>
  );
};

export default React.memo(BeneficiaryWork);
